import type { FormObject, FormObjectContentWithKey } from './reducer';

export type GetArrayReturnType = Array<FormObjectContentWithKey>;

export const getArrayFromFields = (fields: FormObject['fields']): GetArrayReturnType => {
    const array: GetArrayReturnType = [];
    Object.entries(fields).forEach((field) => {
        array.push({ ...field[1].inputProps, key: field[0] });
    });

    return array;
};

export const getArrayFromState = (state: FormObject): GetArrayReturnType => getArrayFromFields(state.fields);
